import { onConnect } from './onConnect';
import { onConnectEnd } from './onConnectEnd';
import { onConnectStart } from './onConnectStart';
import { onEdgesDelete } from './onEdgesDelete';
import { onReconnect } from './onReconnect';
import { onReconnectEnd } from './onReconnectEnd';
import { onReconnectStart } from './onReconnectStart';

const noOp = () => {};

export const subscriptions = (reactflow, unSub = true) => {
  if (unSub) {
    return {
      onConnect: noOp,
      onConnectEnd: noOp,
      onConnectStart: noOp,
      onReconnect: noOp,
      onReconnectEnd: noOp,
      onReconnectStart: noOp,
      onEdgesDelete: noOp,
    };
  }
  return {
    onConnect: onConnect(reactflow),
    onConnectEnd: onConnectEnd(reactflow),
    onConnectStart: onConnectStart(reactflow),
    onReconnect: onReconnect(reactflow),
    onReconnectEnd: onReconnectEnd(reactflow),
    onReconnectStart: onReconnectStart(reactflow),
    onEdgesDelete: onEdgesDelete(reactflow),
  };
};
